<template>
  <button @click.stop="btnClick" class="blue-btn">
    <slot /> <span v-if="title">{{ title }}</span>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    btnClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="less">
.blue-btn {
  display: block;
  width: 90%;
  margin: auto;
  color: #fff;
  font-size: 1.13rem;
  line-height: 2.94rem;
  text-align: center;
  background-color: #108eee;
  border-width: 0;
  border-radius: 0.31rem;
}
</style>
